import { render, staticRenderFns } from "./AssociatedBox.vue?vue&type=template&id=3a19b054&scoped=true"
import script from "./AssociatedBox.vue?vue&type=script&lang=js"
export * from "./AssociatedBox.vue?vue&type=script&lang=js"
import style0 from "./AssociatedBox.vue?vue&type=style&index=0&id=3a19b054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19b054",
  null
  
)

export default component.exports